// @ts-nocheck
import React, { lazy } from 'react';
import classNames from 'classnames';

import { T, Dialog, DialogSuspense } from '@/components';
import withDialogRedux from '@/components/DialogReduxConnect';
import { CLASSES } from '@/constants/classes';
import { compose } from '@/utils';

// Lazy loading the content.
const PdfPreviewDialogContent = lazy(() =>
  import('./SalesOrderPdfPreviewDialogContent'),
);

/**
 * Sales Order PDF preview dialog.
 */
function SalesOrderPdfPreviewDialog({ dialogName, payload, isOpen }) {
  console.log('SalesOrderPdfPreviewDialog payload', payload);
  return (
    <Dialog
      name={dialogName}
      title={<T id={'sales_order_preview.dialog.title'} />}
      className={classNames(CLASSES.DIALOG_PDF_PREVIEW)}
      autoFocus={true}
      canEscapeKeyClose={true}
      isOpen={isOpen}
    >
      <DialogSuspense>
        <PdfPreviewDialogContent
          dialogName={dialogName}
          subscriptionForm={payload}
        />
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(SalesOrderPdfPreviewDialog);
